module.exports = __webpack_public_path__ + "static/media/speaker1.f3c6d5bb.jpg";